import { render, staticRenderFns } from "./SalesDeliveryViewDetails.vue?vue&type=template&id=147e26bf&"
import script from "./SalesDeliveryViewDetails.vue?vue&type=script&lang=js&"
export * from "./SalesDeliveryViewDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports